export default __webpack_public_path__ + "static/media/img8.3e08713d.jpg";